<template>
  <el-dialog
    :title="isEdit ? '编辑货品' : '添加货品'"
    :visible.sync="dialogVisible"
    width="1000px"
    class="goods-form-dialog"
    :close-on-click-modal="false"
    @close="handleClose"
    @open="handleOpen"
  >
    <el-form
      ref="goodsForm"
      :model="formData"
      :rules="formRules"
      label-width="110px"
      size="small"
    >
      <!-- 基本信息 -->
      <div class="form-section-title">基本信息</div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="货品名" prop="goodsName">
            <el-input v-model="formData.goodsName" placeholder="请输入货品名" maxlength="50" show-word-limit />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="类目" prop="category">
            <el-popover
              placement="bottom-start"
              trigger="click"
              width="600"
              v-model="categoryPopoverVisible"
            >
              <div style="display:flex;height:350px;border:1px solid #ebeef5;border-radius:4px;overflow:hidden;">
                <!-- 左侧一级菜单 -->
                <div style="width:130px;background:#f5f7fa;overflow-y:auto;border-right:1px solid #ebeef5;flex-shrink:0;">
                  <div
                    v-for="(menu, idx) in categoryMenus"
                    :key="menu.id"
                    class="category-menu-item"
                    :class="{ active: activeCategoryMenu === idx }"
                    @click="activeCategoryMenu = idx; activeCategoryTab = 0; loadCategoryTabs(idx)"
                    style="padding:10px 14px;cursor:pointer;font-size:13px;border-bottom:1px solid #ebeef5;transition:all 0.2s;"
                  >
                    {{ menu.name }}
                  </div>
                </div>
                <!-- 右侧 -->
                <div style="flex:1;display:flex;flex-direction:column;overflow:hidden;">
                  <!-- 二级tab -->
                  <div style="display:flex;flex-wrap:nowrap;overflow-x:auto;padding:8px 12px;border-bottom:1px solid #ebeef5;flex-shrink:0;gap:6px;">
                    <span
                      v-for="(tab, idx) in categoryTabs"
                      :key="tab.id"
                      class="category-tab-item"
                      :class="{ active: activeCategoryTab === idx }"
                      @click="activeCategoryTab = idx; loadCategoryItems(idx)"
                      style="padding:4px 14px;border-radius:14px;font-size:13px;cursor:pointer;white-space:nowrap;background:#f5f7fa;transition:all 0.2s;"
                    >
                      {{ tab.comlist_v1 }}
                    </span>
                    <span v-if="categoryTabs.length === 0" style="color:#999;font-size:13px;padding:4px 0;">无子类目</span>
                  </div>
                  <!-- 三级列表 -->
                  <div style="flex:1;overflow-y:auto;padding:12px 16px;display:flex;flex-wrap:wrap;align-content:flex-start;gap:8px;">
                    <span
                      v-for="item in categoryItems"
                      :key="item.id"
                      class="category-item-tag"
                      @click="selectCategory(item)"
                      style="padding:6px 16px;border-radius:14px;font-size:13px;cursor:pointer;background:#f0f2f5;transition:all 0.2s;border:1px solid transparent;"
                    >
                      {{ item.comlist_v1 }}
                    </span>
                    <span v-if="categoryItems.length === 0" style="color:#999;font-size:13px;padding:8px 0;">请选择类目</span>
                  </div>
                </div>
              </div>
              <el-input
                slot="reference"
                v-model="formData.category"
                placeholder="请选择类目"
                readonly
                style="cursor:pointer;"
              />
            </el-popover>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="分组" prop="groupId">
            <el-select v-model="formData.groupId" placeholder="请选择分组" style="width:100%;">
              <el-option
                v-for="item in groupList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="商品标签">
            <el-select v-model="formData.goodsTypeIds" multiple placeholder="请选择商品标签" style="width:100%;" clearable>
              <el-option
                v-for="item in goodsTypeList"
                :key="item.id"
                :label="item.bfenlei4"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
       <!-- <el-col :span="12">
          <el-form-item label="品牌">
            <el-select v-model="formData.brandId" placeholder="请选择品牌" style="width:100%;" clearable>
              <el-option
                v-for="item in brandList"
                :key="item.id"
                :label="item.bfenlei4"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item label="退换货标签">
            <el-select v-model="formData.returnId" placeholder="请选择退换货标签" style="width:100%;" clearable>
              <el-option
                v-for="item in returnList"
                :key="item.id"
                :label="item.bfenlei4"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col> -->
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="产地">
            <el-input v-model="formData.origin" placeholder="请输入产地" />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="运费模板" prop="freightTempId">
            <el-select v-model="formData.freightTempId" placeholder="请选择运费模板" style="width:100%;">
              <el-option
                v-for="item in freightList"
                :key="item.id"
                :label="item.temp_name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col> -->
      </el-row>

      <!-- 规格与计价 -->
      <div class="form-section-title">规格与计价</div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="规格" prop="specMode">
            <el-radio-group v-model="formData.specMode" @change="onSpecModeChange">
              <el-radio label="single">单规格</el-radio>
              <el-radio label="multi">多规格</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="计价方式" prop="pricingType">
            <el-radio-group v-model="formData.pricingType" @change="onPricingChange">
              <el-radio label="count">计数</el-radio>
              <el-radio label="weight">整件称重</el-radio>
              <el-radio label="split">拆零</el-radio>
              <el-radio label="bulk">散称</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 单规格 -->
      <template v-if="formData.specMode === 'single'">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="规格名称" prop="singleSpecName">
              <el-input v-model="formData.singleSpecName" placeholder="请输入规格名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="['count','split'].includes(formData.pricingType)">
            <el-form-item label="单位" prop="singleUnit">
              <el-select v-model="formData.singleUnit" placeholder="请选择单位" style="width:100%;" filterable allow-create>
                <el-option v-for="u in unitList" :key="u" :label="u" :value="u" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="售价" prop="singleSalePrice">
              <el-input v-model="formData.singleSalePrice" placeholder="请输入售价" type="number" step="0.01">
                <template slot="append">
                  元/{{ formData.pricingType === 'weight' || formData.pricingType === 'bulk' ? 'kg' : (formData.singleUnit || '件') }}
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="会员价">
              <el-input v-model="formData.singleHrPrice" placeholder="请输入会员价" type="number" step="0.01">
                <template slot="append">
                  元/{{ formData.pricingType === 'weight' || formData.pricingType === 'bulk' ? 'kg' : (formData.singleUnit || '件') }}
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="formData.pricingType !== 'bulk'">
          <el-col :span="12" v-if="formData.pricingType !== 'weight'">
            <el-form-item label="平均重量">
              <el-input v-model="formData.singleAvgWeight" placeholder="请输入平均重量" type="number" step="0.001">
                <template slot="append">kg</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="['weight','split'].includes(formData.pricingType)">
            <el-form-item label="固定皮重">
              <el-input v-model="formData.singleTareWeight" placeholder="请输入固定皮重" type="number" step="0.001">
                <template slot="append">kg</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="编码">
              <el-input v-model="formData.singleCode" placeholder="请输入编码" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <!-- 多规格 -->
      <template v-if="formData.specMode === 'multi'">
        <el-form-item label="规格列表" prop="specDetails">
          <div class="multi-spec-list">
            <div
              v-for="(spec, idx) in formData.specDetails"
              :key="idx"
              class="spec-item-row"
              @click="openSpecDetail(idx)"
            >
              <span class="spec-item-name">{{ spec.name || `规格${idx+1}` }}</span>
              <span class="spec-item-info">
                <template v-if="spec.sale_price">
                  {{ spec.unit || '' }} ¥<span class="price">{{ spec.sale_price }}</span>
                  <span v-if="spec.hr_price"> / 会员 ¥{{ spec.hr_price }}</span>
                </template>
                <span v-else style="color:#999;">请补充售价等信息</span>
              </span>
              <span class="spec-item-actions">
                <el-button size="mini" type="danger" plain @click.stop="removeSpec(idx)" :disabled="formData.specDetails.length <= 1">删除</el-button>
              </span>
            </div>
            <el-button size="small" type="primary" plain @click="addSpec" style="margin-top:6px;">
              <i class="el-icon-plus"></i> 添加规格
            </el-button>
          </div>
        </el-form-item>
      </template>

      <!-- 销售设置 -->
      <div class="form-section-title">销售设置</div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="起订量">
            <el-input v-model="formData.miniNum" placeholder="请输入起订量" type="number" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="货品预售">
            <el-switch v-model="formData.preSale" active-text="开启" inactive-text="关闭" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="formData.preSale">
        <el-col :span="12">
          <el-form-item label="预售时间">
            <el-date-picker
              v-model="formData.preSaleDate"
              type="date"
              placeholder="请选择预售日期"
              value-format="yyyy-MM-dd"
              style="width:100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 扶贫信息 -->
      <div class="form-section-title">商品产地</div>
      <div class="poverty-section">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="省份">
              <el-select v-model="formData.povertyProvinceId" placeholder="请选择省份" style="width:100%;" @change="onPovertyProvinceChange" clearable>
                <el-option v-for="p in povertyProvinces" :key="p.id" :label="p.name" :value="p.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="城市">
              <el-select v-model="formData.povertyCityId" placeholder="请选择城市" style="width:100%;" @change="onPovertyCityChange" clearable :disabled="!formData.povertyProvinceId">
                <el-option v-for="c in povertyCities" :key="c.id" :label="c.name" :value="c.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="区县">
              <el-select v-model="formData.povertyDistrictId" placeholder="请选择区县" style="width:100%;" clearable :disabled="!formData.povertyCityId">
                <el-option v-for="d in povertyDistricts" :key="d.id" :label="d.name" :value="d.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 扶贫企业（已注释，保留备选） -->
      </div>

      <!-- 图片 -->
      <div class="form-section-title">图片</div>
      <el-form-item label="主图" prop="mainImageUrl">
        <div class="main-image-upload" @click="uploadMainImage">
          <img v-if="formData.mainImageUrl" :src="formData.mainImageUrl" class="main-image-preview" />
          <div v-else class="upload-placeholder">
            <i class="el-icon-plus"></i>
            <span>上传主图</span>
          </div>
        </div>
        <!-- 不需要隐藏域，直接使用 mainImageUrl -->
      </el-form-item>

      <el-form-item label="产品图片">
        <!--           :autoUpload="false" -->
        <unload-media
          v-model="formData.uploadedFiles"
          :maxCount="9"
          title="产品图片"
          buttonText="添加"
          :uploadUrl="uploadUrl"
          :fileTypes="['image']"
          :auto-upload="false"
          :maxFileSize="100"
          @change="onFilesChange"
        />
      </el-form-item>

      <div class="form-section-title">商品详情</div>
      <el-form-item label="详情内容" prop="detailComponents" style="padding:0;">
        <page-editor
          ref="pageEditor"
          :initial-components="formData.detailComponents"
          title="商品详情"
          :show-footer="false"
          :auto-save="false"
          @components-update="onComponentsUpdate"
        />
      </el-form-item>
    </el-form>

    <!-- 规格详情编辑弹窗（多规格） -->
    <el-dialog
      title="规格详情"
      :visible.sync="showSpecDetailDialog"
      width="560px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form label-width="100px" size="small" ref="specDetailForm">
        <el-form-item label="规格名称">
          <el-input v-model="editingSpec.name" placeholder="请输入规格名称" />
        </el-form-item>

        <template v-if="['count','split'].includes(formData.pricingType)">
          <el-form-item label="单位">
            <el-select v-model="editingSpec.unit" placeholder="请选择单位" style="width:100%;" filterable allow-create>
              <el-option v-for="u in unitList" :key="u" :label="u" :value="u" />
            </el-select>
          </el-form-item>
        </template>

        <el-form-item label="售价">
          <el-input v-model="editingSpec.sale_price" placeholder="请输入售价" type="number" step="0.01">
            <template slot="append">
              元/{{ formData.pricingType === 'weight' || formData.pricingType === 'bulk' ? 'kg' : (editingSpec.unit || '件') }}
            </template>
          </el-input>
        </el-form-item>

        <el-form-item label="会员价">
          <el-input v-model="editingSpec.hr_price" placeholder="请输入会员价" type="number" step="0.01">
            <template slot="append">
              元/{{ formData.pricingType === 'weight' || formData.pricingType === 'bulk' ? 'kg' : (editingSpec.unit || '件') }}
            </template>
          </el-input>
        </el-form-item>

        <template v-if="formData.pricingType !== 'bulk'">
          <el-form-item label="平均重量" v-if="formData.pricingType !== 'weight'">
            <el-input v-model="editingSpec.average_weight" placeholder="请输入平均重量" type="number" step="0.001">
              <template slot="append">kg</template>
            </el-input>
          </el-form-item>
          <el-form-item label="固定皮重" v-if="['weight','split'].includes(formData.pricingType)">
            <el-input v-model="editingSpec.tare_weight" placeholder="请输入固定皮重" type="number" step="0.001">
              <template slot="append">kg</template>
            </el-input>
          </el-form-item>
        </template>

        <el-form-item label="编码">
          <el-input v-model="editingSpec.code" placeholder="请输入编码" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSpecDetailDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmSpecDetail">确认</el-button>
      </span>
    </el-dialog>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="submitForm" :loading="formSubmitting">
        {{ isEdit ? '保存修改' : '确认添加' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '@/utils/request'
import xcxrequest from '@/utils/xcxrequest'
import unloadMedia from '../../components/unioadImage/unloadImage.vue'
import PageEditor from '../../components/pageMain/pageMain.vue'

export default {
  name: 'GoodsFormDialog',
  components: {
    unloadMedia,
    PageEditor
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'add' // 'add' | 'edit'
    },
    goodsId: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      dialogVisible: this.visible,
      formSubmitting: false,
      uploadUrl: '', // 可配置实际上传地址
      // 表单数据
      formData: this.getDefaultFormData(),
      formRules: {
        goodsName: [{ required: true, message: '请输入货品名', trigger: 'blur' }],
        category: [{ required: true, message: '请选择类目', trigger: 'change' }],
        groupId: [{ required: true, message: '请选择分组', trigger: 'change' }],
        // freightTempId: [{ required: true, message: '请选择运费模板', trigger: 'change' }],
        singleSpecName: [{ required: true, message: '请输入规格名称', trigger: 'blur' }],
        singleSalePrice: [{ required: true, message: '请输入售价', trigger: 'blur' }],
        mainImageUrl: [{ required: true, message: '请上传主图', trigger: 'change' }]
      },
      // 类目相关
      categoryPopoverVisible: false,
      activeCategoryMenu: 0,
      activeCategoryTab: 0,
      categoryMenus: [],
      categoryTabs: [],
      categoryItems: [],
      level_1: [],
      level_2: [],
      level_3: [],
      // 下拉列表数据
      groupList: [],
      brandList: [],
      goodsTypeList: [],
      returnList: [],
      freightList: [],
      unitList: [
        '件', '瓶', '只', '张', '层', '袋', '盒', '提', '筐', '板',
        '把', '支', '捆', '卷', '对', '箱', '份', '杯', '篮', '挂',
        '包', '个', '罐', '桶', '条', '粒', '束', '根', '串', '盘'
      ],
      // 扶贫
      povertyProvinces: [],
      povertyCities: [],
      povertyDistricts: [],
      // 规格详情编辑
      showSpecDetailDialog: false,
      editingSpecIndex: -1,
      editingSpec: {}
    }
  },
  computed: {
    isEdit () {
      return this.mode === 'edit'
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('update:visible', val)
      if (!val) {
        this.$emit('close')
      }
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    // ---------- 初始化 ----------
    async initData () {
      await this.fetchGroupList()
      await this.loadTagsAndBrands()
      await this.getFreightTemplates()
      await this.getLeimu()
      await this.loadPovertyProvinces()
    },
    // 获取产品图片
    async loadProductImages (goodsId) {
      try {
        const userType = localStorage.getItem('user_type') || ''
        const res = await request.post('/index/upload_goods_get.php', {
          user_type: userType,
          goods_id: goodsId
        })
        if (res.code === 0 && Array.isArray(res.list)) {
          this.formData.uploadedFiles = res.list.map(item => {
            const imageUrl = item.comlist_v2 || ''
            const fileName = item.comlist_v1 || 'file'
            let fileType = 'image'
            // 根据 URL 后缀判断是否为视频
            if (imageUrl && /\.(mp4|avi|mov|wmv|flv|mkv|webm)$/i.test(imageUrl)) {
              fileType = 'video'
            }
            return {
              id: item.id,
              type: fileType,
              name: fileName,
              url: imageUrl,
              path: imageUrl,
              size: 0,
              duration: 0,
              poster: '', // 如果有视频封面图字段可补充
              uploaded: true // 标记为已上传
            }
          })
        } else {
          this.formData.uploadedFiles = []
        }
      } catch (error) {
        console.error('加载产品图片失败:', error)
        this.formData.uploadedFiles = []
      }
    },
    // ---------- 获取基础数据 ----------
    async fetchGroupList () {
      try {
        const shopId = localStorage.getItem('sh_id') || '2'
        const res = await request.post('/goods/fenzu_jiben_list.php', { bfenlei1: shopId })
        if (res && res.code === 0 && Array.isArray(res.fenzuList)) {
          this.groupList = res.fenzuList.map(item => ({
            id: item.id,
            name: item.bfenlei4
          }))
        }
      } catch (e) { console.error(e) }
    },
    async loadTagsAndBrands () {
      try {
        const shopId = localStorage.getItem('sh_id') || '2'
        const tagRes = await request.post('/goods/fenzu_jiben_list.php', { bfenlei1: shopId, bfenlei2: '502' })
        if (tagRes.code === 0 && tagRes.fenzuList) this.goodsTypeList = tagRes.fenzuList
        const brandRes = await request.post('/goods/fenzu_jiben_list.php', { bfenlei1: shopId, bfenlei2: '501' })
        if (brandRes.code === 0 && brandRes.fenzuList) this.brandList = brandRes.fenzuList
        const returnRes = await request.post('/goods/fenzu_jiben_list.php', { bfenlei1: shopId, bfenlei2: '503' })
        if (returnRes.code === 0 && returnRes.fenzuList) this.returnList = returnRes.fenzuList
      } catch (e) { console.error(e) }
    },
    async getFreightTemplates () {
      try {
        const shopId = localStorage.getItem('sh_id') || '2'
        const res = await request.post('/common/freight.php?a=temp_sel', { sh_id: shopId, is_goods: 1 })
        if (res.code === 0 && res.data && res.data.length > 0) {
          this.freightList = res.data
        }
      } catch (e) { console.error(e) }
    },
    async getLeimu () {
      try {
        const res = await request.post('/goods/goods_jiben_lei.php')
        if (res.code === 0) {
          this.level_1 = res.level_1 || []
          this.level_2 = res.level_2 || []
          this.level_3 = res.level_3 || []
          this.categoryMenus = this.level_1.map(item => ({
            id: item.id,
            name: item.comlist_v1
          }))
          if (this.categoryMenus.length) {
            this.activeCategoryMenu = 0
            this.loadCategoryTabs(0)
          }
        }
      } catch (e) { console.error(e) }
    },
    loadCategoryTabs (menuIdx) {
      const menu = this.categoryMenus[menuIdx]
      if (!menu) return
      this.categoryTabs = this.level_2.filter(item => item.parent_id === menu.id)
      this.activeCategoryTab = 0
      this.loadCategoryItems(0)
    },
    loadCategoryItems (tabIdx) {
      const tab = this.categoryTabs[tabIdx]
      if (tab) {
        this.categoryItems = this.level_3.filter(item => item.parent_id === tab.id)
      } else {
        const menu = this.categoryMenus[this.activeCategoryMenu]
        this.categoryItems = this.level_3.filter(item => item.parent_id === menu.id)
      }
    },
    selectCategory (item) {
      const level2 = this.level_2.find(l2 => l2.id === item.parent_id)
      const level1 = level2 ? this.level_1.find(l1 => l1.id === level2.parent_id) : null
      this.formData.categoryId = item.id
      this.formData.category = item.comlist_v1
      this.formData.comlist_v2_1 = level1 ? level1.id : ''
      this.formData.comlist_v2_2 = level2 ? level2.id : ''
      this.categoryPopoverVisible = false
      this.$refs.goodsForm && this.$refs.goodsForm.validateField('category')
    },

    // ---------- 扶贫 ----------
    async loadPovertyProvinces () {
      try {
        const res = await xcxrequest.post('/gouwu/address.php?a=provinces')
        if (res.code === '0' && res.data) this.povertyProvinces = res.data
      } catch (e) { console.error(e) }
    },
    async onPovertyProvinceChange (provinceId) {
      this.formData.povertyCityId = null
      this.formData.povertyDistrictId = null
      this.povertyCities = []
      this.povertyDistricts = []
      if (provinceId) {
        const res = await xcxrequest.post('/gouwu/address.php?a=cities', { province_id: provinceId })
        if (res.code === '0' && res.data) this.povertyCities = res.data
      }
    },
    async onPovertyCityChange (cityId) {
      this.formData.povertyDistrictId = null
      this.povertyDistricts = []
      if (cityId) {
        const res = await xcxrequest.post('/gouwu/address.php?a=districts', { city_id: cityId })
        if (res.code === '0' && res.data) this.povertyDistricts = res.data
      }
    },

    // ---------- 表单默认数据 ----------
    getDefaultFormData () {
      return {
        goodsName: '',
        category: '',
        categoryId: null,
        comlist_v2_1: '',
        comlist_v2_2: '',
        groupId: null,
        brandId: null,
        goodsTypeIds: [],
        returnId: null,
        origin: '',
        freightTempId: null,
        specMode: 'single',
        pricingType: 'count',
        singleSpecName: '',
        singleUnit: '件',
        singleSalePrice: '',
        singleHrPrice: '',
        singleAvgWeight: '',
        singleTareWeight: '',
        singleCode: '',
        specDetails: [
          { name: '', unit: '件', sale_price: '', hr_price: '', average_weight: '', tare_weight: '', code: '' }
        ],
        miniNum: '',
        preSale: false,
        preSaleDate: '',
        povertyProvinceId: null,
        povertyCityId: null,
        povertyDistrictId: null,
        mainImageUrl: '',
        uploadedFiles: [],
        detailComponents: []
      }
    },

    // ---------- 弹窗打开/关闭 ----------
    async handleOpen () {
      if (this.isEdit && this.goodsId) {
        await this.loadGoodsDetail(this.goodsId)
        await this.loadProductImages(this.goodsId)
      } else {
        this.formData = this.getDefaultFormData()
        if (this.groupList.length) {
          this.formData.groupId = this.groupList[0].id
        }
        this.$nextTick(() => {
          if (this.$refs.pageEditor) {
            this.$refs.pageEditor.clearComponents()
          }
        })
      }
      this.$nextTick(() => {
        if (this.$refs.goodsForm) {
          this.$refs.goodsForm.clearValidate()
        }
      })
    },
    handleClose () {
      this.dialogVisible = false
      this.formSubmitting = false
      if (this.$refs.goodsForm) {
        this.$refs.goodsForm.resetFields()
      }
    },

    // ---------- 加载编辑数据 ----------
    async loadGoodsDetail (goodsId) {
      const shopId = localStorage.getItem('sh_id') || '2'
      const userType = localStorage.getItem('user_type') || ''
      const res = await request.post('/goods/goods_jiben_list.php', {
        ShopId: shopId,
        id: goodsId,
        user_type: userType
      })
      console.log(res)
      if (res.code === 0 && res.data && res.data.length > 0) {
        const data = res.data[0]
        const main = data.goods_main[0]
        const mxList = data.goods_mx || []
        const labels = data.goods_label || []

        // 填充表单
        this.formData.goodsName = main.comlist_v1 || ''
        this.formData.category = main.comlist_v2 || ''
        this.formData.comlist_v2_1 = main.comlist_v2_1 || ''
        this.formData.comlist_v2_2 = main.comlist_v2_2 || ''
        this.formData.origin = main.comlist_v4 || ''
        this.formData.miniNum = main.mini_num || ''
        this.formData.mainImageUrl = main.comlist_v8_y || ''
        this.formData.preSale = main.comlist_v7 === 1
        this.formData.preSaleDate = (main.comlist_d1 && main.comlist_d1 !== '0000-00-00') ? main.comlist_d1 : ''
        this.formData.freightTempId = main.temp_id ? Number(main.temp_id) : null

        // 分组
        const groupName = main.comlist_v5 || ''
        const foundGroup = this.groupList.find(g => g.name === groupName)
        this.formData.groupId = foundGroup ? foundGroup.id : (this.groupList.length ? this.groupList[0].id : null)

        // 品牌
        const brandName = main.comlist_v3 || ''
        const foundBrand = this.brandList.find(b => b.bfenlei4 === brandName)
        this.formData.brandId = foundBrand ? foundBrand.id : null

        // 标签
        this.formData.goodsTypeIds = []
        this.formData.returnId = null
        labels.forEach(label => {
          if (label.fenlei === 1) this.formData.goodsTypeIds.push(label.label_id)
          else if (label.fenlei === 2) this.formData.returnId = label.label_id
        })

        // 规格
        const typeMap = { 计数: 'count', 整件称重: 'weight', 拆零: 'split', 散称: 'bulk' }
        if (mxList.length > 1) {
          this.formData.specMode = 'multi'
          this.formData.specDetails = mxList.map(mx => ({
            mx_id: mx.id,
            name: mx.comlist_v1 || '',
            unit: mx.comlist_v2 || '件',
            sale_price: mx.comlist_f2 || '',
            hr_price: mx.comlist_f2_1 || '',
            average_weight: mx.comlist_f3 || '',
            tare_weight: mx.comlist_v5 || '',
            code: mx.comlist_v3 || ''
          }))
          this.formData.pricingType = typeMap[mxList[0]?.type] || 'count'
        } else if (mxList.length === 1) {
          this.formData.specMode = 'single'
          const mx = mxList[0]
          this.formData.singleSpecName = mx.comlist_v1 || ''
          this.formData.singleUnit = mx.comlist_v2 || '件'
          this.formData.singleSalePrice = mx.comlist_f2 || ''
          this.formData.singleHrPrice = mx.comlist_f2_1 || ''
          this.formData.singleAvgWeight = mx.comlist_f3 || ''
          this.formData.singleTareWeight = mx.comlist_v5 || ''
          this.formData.singleCode = mx.comlist_v3 || ''
          this.formData.pricingType = typeMap[mx.type] || 'count'
          this.formData.specDetails = [
            { name: this.formData.singleSpecName, unit: this.formData.singleUnit, sale_price: this.formData.singleSalePrice, hr_price: this.formData.singleHrPrice, average_weight: this.formData.singleAvgWeight, tare_weight: this.formData.singleTareWeight, code: this.formData.singleCode }
          ]
        }

        // 扶贫
        const firstMx = mxList[0] || {}
        this.formData.povertyProvinceId = firstMx.province_id ? Number(firstMx.province_id) : null
        this.formData.povertyCityId = firstMx.city_id ? Number(firstMx.city_id) : null
        this.formData.povertyDistrictId = firstMx.dist_id ? Number(firstMx.dist_id) : null
        if (this.formData.povertyProvinceId) {
          await this.onPovertyProvinceChange(this.formData.povertyProvinceId)
          if (this.formData.povertyCityId) {
            await this.onPovertyCityChange(this.formData.povertyCityId)
          }
        }

        // 商品详情
        const pageMainStr = main.page_main || '[]'
        try {
          const cleanStr = pageMainStr
            .replace(/&quot;/g, '"')
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r')
            .replace(/\t/g, '\\t')
          const parsed = JSON.parse(cleanStr)
          this.formData.detailComponents = Array.isArray(parsed) ? parsed : []
        } catch (e) {
          console.warn('解析 page_main 失败，使用空数组', e)
          this.formData.detailComponents = []
        }
        this.formData.uploadedFiles = []

        this.$nextTick(() => {
          if (this.$refs.pageEditor) {
            this.$refs.pageEditor.setComponents(this.formData.detailComponents)
          }
        })
      }
    },

    // ---------- 规格模式切换 ----------
    onSpecModeChange (val) {
      if (val === 'single') {
        if (this.formData.specDetails.length) {
          const first = this.formData.specDetails[0]
          this.formData.singleSpecName = first.name || ''
          this.formData.singleUnit = first.unit || '件'
          this.formData.singleSalePrice = first.sale_price || ''
          this.formData.singleHrPrice = first.hr_price || ''
          this.formData.singleAvgWeight = first.average_weight || ''
          this.formData.singleTareWeight = first.tare_weight || ''
          this.formData.singleCode = first.code || ''
        }
      } else {
        this.formData.specDetails = [{
          name: this.formData.singleSpecName || '规格1',
          unit: this.formData.singleUnit || '件',
          sale_price: this.formData.singleSalePrice || '',
          hr_price: this.formData.singleHrPrice || '',
          average_weight: this.formData.singleAvgWeight || '',
          tare_weight: this.formData.singleTareWeight || '',
          code: this.formData.singleCode || ''
        }]
      }
    },
    onPricingChange () {},

    // ---------- 多规格操作 ----------
    addSpec () {
      this.formData.specDetails.push({
        name: '',
        unit: (this.formData.pricingType === 'count' || this.formData.pricingType === 'split') ? '件' : '',
        sale_price: '',
        hr_price: '',
        average_weight: '',
        tare_weight: '',
        code: ''
      })
    },
    removeSpec (index) {
      if (this.formData.specDetails.length > 1) {
        this.formData.specDetails.splice(index, 1)
      }
    },
    openSpecDetail (index) {
      this.editingSpecIndex = index
      this.editingSpec = { ...this.formData.specDetails[index] }
      this.showSpecDetailDialog = true
    },
    confirmSpecDetail () {
      if (this.editingSpecIndex >= 0) {
        this.$set(this.formData.specDetails, this.editingSpecIndex, { ...this.editingSpec })
      }
      this.showSpecDetailDialog = false
    },

    // ---------- 主图上传（使用 /admin/report.php） ----------
    async uploadMainImage () {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.onchange = async (e) => {
        const file = e.target.files[0]
        if (!file) return

        const shopId = localStorage.getItem('sh_id') || '2'
        const userName = localStorage.getItem('user_name') || ''
        const token = localStorage.getItem('token') || ''

        const formData = new FormData()
        formData.append('a', 'upload')
        formData.append('shop_id', shopId)
        formData.append('type', 'main')
        formData.append('fenlei', '40')
        formData.append('comlist2', userName)
        formData.append('file', file)

        try {
          const res = await fetch('https://caixiao.lianglianyn.com/admin/report.php', {
            method: 'POST',
            headers: { comlistToken: token },
            body: formData
          })
          const data = await res.json()
          if (data.code === '0') {
            const url = data.url || data.data?.url
            if (url) {
              this.formData.mainImageUrl = url
              // 手动触发校验
              if (this.$refs.goodsForm) {
                this.$refs.goodsForm.validateField('mainImageUrl')
              }
              this.$message.success('主图上传成功')
            } else {
              this.$message.error('上传成功但未返回图片地址')
            }
          } else {
            this.$message.error(data.msg || '主图上传失败')
          }
        } catch (error) {
          console.error('主图上传异常:', error)
          this.$message.error('主图上传失败，请重试')
        }
      }
      input.click()
    },

    // ---------- unloadMedia 事件 ----------
    onFilesChange (event) {},

    // ---------- PageEditor 事件 ----------
    onComponentsUpdate (components) {
      this.formData.detailComponents = components
    },

    // ---------- 上传产品图片 ----------
    async uploadProductImages () {
      const files = this.formData.uploadedFiles
      if (!files || files.length === 0) return []
      const uploadedUrls = []
      const shopId = localStorage.getItem('sh_id')
      const userName = localStorage.getItem('user_name') || ''
      const userType = localStorage.getItem('user_type') || ''
      const token = localStorage.getItem('token') || ''

      for (const file of files) {
        if (file.uploaded && file.url) {
          uploadedUrls.push(file.url)
          continue
        }
        const formData = new FormData()
        const response = await fetch(file.path)
        const blob = await response.blob()
        formData.append('file', blob, file.name || 'file.jpg')
        formData.append('comlist2', userName)
        formData.append('user_type', userType)
        formData.append('comlistToken', token)
        if (shopId)formData.append('sh_id', shopId)

        try {
          const uploadRes = await fetch('https://caixiao.lianglianyn.com/index/upload_goods.php', {
            method: 'POST',
            headers: { comlistToken: token },
            body: formData
          })
          const data = await uploadRes.json()
          if (data.code === 0 && data.url) {
            file.url = data.url
            file.uploaded = true
            uploadedUrls.push(data.url)
          } else {
            this.$message.error(`文件 ${file.name} 上传失败: ${data.msg || '未知错误'}`)
            return null
          }
        } catch (e) {
          console.error('上传失败', e)
          this.$message.error(`文件 ${file.name} 上传失败`)
          return null
        }
      }
      return uploadedUrls
    },

    // ---------- 提交表单 ----------
    async submitForm () {
      this.$refs.goodsForm.validate(async (valid) => {
        if (!valid) {
          this.$message.warning('请完善表单信息')
          return
        }
        if (!this.formData.mainImageUrl) {
          this.$message.warning('请上传主图')
          return
        }

        this.formSubmitting = true
        try {
          const uploadedUrls = await this.uploadProductImages()
          if (uploadedUrls === null) {
            this.formSubmitting = false
            return
          }

          const detailComponents = this.$refs.pageEditor ? this.$refs.pageEditor.getComponents() : []
          const pageMainJson = JSON.stringify(detailComponents)

          const shopId = localStorage.getItem('sh_id') || '2'
          const userType = localStorage.getItem('user_type') || ''
          const userId = localStorage.getItem('user_id') || ''
          const workId = localStorage.getItem('work_id') || ''
          const userName = localStorage.getItem('user_name') || ''

          let mxList = []
          if (this.formData.specMode === 'single') {
            const mx = {
              mx_comlist_v1: this.formData.singleSpecName,
              mx_comlist_v2: (this.formData.pricingType === 'count' || this.formData.pricingType === 'split') ? this.formData.singleUnit : '',
              mx_comlist_v3: this.formData.singleCode || '',
              mx_comlist_v5: (this.formData.pricingType === 'weight' || this.formData.pricingType === 'split') ? this.formData.singleTareWeight : '',
              mx_comlist_f2: this.formData.singleSalePrice,
              mx_comlist_f2_1: this.formData.singleHrPrice || '',
              mx_comlist_f3: (this.formData.pricingType !== 'bulk' && this.formData.pricingType !== 'weight') ? this.formData.singleAvgWeight : ''
            }
            if (this.isEdit && this.formData.specDetails[0]?.mx_id) {
              mx.mx_id = this.formData.specDetails[0].mx_id
            }
            mxList = [mx]
          } else {
            mxList = this.formData.specDetails.map(spec => ({
              mx_comlist_v1: spec.name,
              mx_comlist_v2: (this.formData.pricingType === 'count' || this.formData.pricingType === 'split') ? (spec.unit || '件') : '',
              mx_comlist_v3: spec.code || '',
              mx_comlist_v5: (this.formData.pricingType === 'weight' || this.formData.pricingType === 'split') ? (spec.tare_weight || '') : '',
              mx_comlist_f2: spec.sale_price || '',
              mx_comlist_f2_1: spec.hr_price || '',
              mx_comlist_f3: (this.formData.pricingType !== 'bulk' && this.formData.pricingType !== 'weight') ? (spec.average_weight || '') : '',
              mx_id: spec.mx_id || ''
            }))
          }

          const labelArray = []
          this.formData.goodsTypeIds.forEach(id => {
            labelArray.push({ label_id: id, fenlei: 1, sh_id: shopId })
          })
          if (this.formData.returnId) {
            labelArray.push({ label_id: this.formData.returnId, fenlei: 2, sh_id: shopId })
          }

          const params = {
            shopId: shopId,
            comlist2: userName,
            user_id: userId,
            work_id: workId,
            user_type: userType,
            comlist_v1: this.formData.goodsName,
            comlist_v2: this.formData.category,
            comlist_v2_1: this.formData.comlist_v2_1,
            comlist_v2_2: this.formData.comlist_v2_2,
            comlist_v3: this.brandList.find(b => b.id === this.formData.brandId)?.bfenlei4 || '',
            brand_id: this.formData.brandId || '',
            comlist_v4: this.formData.origin || '',
            mini_num: this.formData.miniNum || '',
            comlist_v5: this.groupList.find(g => g.id === this.formData.groupId) || '',
            mx_type: this.formData.pricingType,
            comlist_v6: 0,
            comlist_v7: this.formData.preSale ? 1 : 0,
            comlist_d1: this.formData.preSale ? (this.formData.preSaleDate || '') : '',
            temp_id: this.formData.freightTempId || '',
            comlist_img: this.formData.mainImageUrl || '',
            province_id: this.formData.povertyProvinceId || '',
            city_id: this.formData.povertyCityId || '',
            dist_id: this.formData.povertyDistrictId || '',
            label: labelArray,
            page_main: pageMainJson,
            sh_goods_mx: mxList,
            goods_img_list: uploadedUrls.join(',')
          }

          if (this.isEdit) {
            params.id = this.goodsId
          }

          const url = this.isEdit ? '/goods/goods_jiben_edit.php' : '/goods/goods_jiben_add.php'
          const res = await request.post(url, params)

          if (res.code === 0) {
            this.$message.success(this.isEdit ? '保存成功' : '添加成功')
            this.$emit('success')
            this.handleClose()
          } else {
            this.$message.error(res.msg || '操作失败')
          }
        } catch (e) {
          console.error(e)
          this.$message.error('网络错误，请重试')
        } finally {
          this.formSubmitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
.goods-form-dialog .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
  padding: 20px 30px;
}
.form-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 20px 0 16px 0;
  padding-left: 12px;
  border-left: 4px solid #409EFF;
}
.form-section-title:first-of-type {
  margin-top: 0;
}
.main-image-upload {
  width: 140px;
  height: 140px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  transition: border-color 0.2s;
}
.main-image-upload:hover {
  border-color: #409EFF;
}
.main-image-upload .main-image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-image-upload .upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #999;
  font-size: 13px;
}
.main-image-upload .upload-placeholder .el-icon-plus {
  font-size: 32px;
  margin-bottom: 6px;
}
.poverty-section {
  background: #fef9e6;
  border-radius: 8px;
  padding: 16px 20px 8px 20px;
  margin-top: 8px;
  border: 1px solid #f5e6c8;
}
.multi-spec-list .spec-item-row {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: background 0.2s;
  border: 1px solid transparent;
}
.multi-spec-list .spec-item-row:hover {
  background: #e8ecf1;
  border-color: #d9dce3;
}
.multi-spec-list .spec-item-row .spec-item-name {
  width: 100px;
  font-weight: 500;
  color: #303133;
}
.multi-spec-list .spec-item-row .spec-item-info {
  flex: 1;
  color: #606266;
  font-size: 13px;
}
.multi-spec-list .spec-item-row .spec-item-info .price {
  color: #409EFF;
  font-weight: 500;
}
.multi-spec-list .spec-item-row .spec-item-actions {
  display: flex;
  gap: 6px;
}
.category-menu-item.active {
  background-color: #fff;
  color: #409EFF;
  border-right: 2px solid #409EFF;
}
.category-tab-item.active {
  background-color: #409EFF !important;
  color: #fff !important;
}
.category-item-tag:hover {
  border-color: #409EFF;
  background: #ecf5ff !important;
}
</style>
